import * as React from 'react'
import Loadable from 'react-loadable'

export const LoadableFormBuilder = Loadable({
  loader: () =>
    import(/* webpackChunkName: "widget-formbuilder" */ './formbuilder').then(
      (c) => {
        return c
      }
    ),
  render(loaded, props) {
    const Component = loaded['DynamicForm']
    return <Component {...props} />
  },
  loading: () => null,
  delay: 300
})
